/** Saves a blob to the user's disk under `filename`, through a temporary link. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  // Firefox ignores a click on a link that is not in the document.
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Revoked on the next task: a browser may start reading the URL only after the click handler returns.
  setTimeout(() => URL.revokeObjectURL(url));
}
